module.exports = __webpack_public_path__ + "static/media/calendar-visual.9e98d652.svg";